var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',[(_vm.visible)?_c('v-btn',{staticClass:"scroll-top-btn defult-btn-color",attrs:{"fab":"","small":"","color":"primary"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-angle-double-up"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }